module.exports = __webpack_public_path__ + "img/05010009.bc1ffcf5.jpg";